import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToWords } from 'to-words';
import { ShowBookInvoiceComponent } from '../pages/show-book-invoice/show-book-invoice.component';

@Component({
  selector: 'app-show-book-order',
 // ✅ Needed for *ngFor, *ngIf
  templateUrl: './show-order-entry-book-seller.component.html',
  styleUrls: ['./show-order-entry-book-seller.component.scss'] // ✅ fixed typo
})




export class ShowOrderEntryBookSellerComponent implements OnInit {
  book: any;
  bookinvoice: any[] = [];
  bookinvoicedata: any[] = [];
  total_total = 0;
  shipping_charges_total = 0;
  total_amount = 0;
  shipping_charges = 0;

  totals: number;
  toWords: ToWords;
  amtinwords: string;
  address: string;

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<ShowBookInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('Dialog data:', data);
  }

  ngOnInit(): void {
    this.book = this.data['book'];
    console.log('Book rcpt_id:', this.book['rcpt_id']);

    // ✅ First API: Book Invoice
    this.service.getBookOrderForView(this.book['rcpt_id']).subscribe((data) => {
      console.log('Book invoice:', data);
      this.bookinvoice = data;

      if (!this.bookinvoice.length) {
        this.dialogRef.close();
        alert('Receipt is not Present.');
      } else {
        // ✅ Set address only after data is available
        this.address = `${this.bookinvoice[0]?.receiver_address || ''} ${this.bookinvoice[0]?.taluka || ''}, ${this.bookinvoice[0]?.district || ''}, ${this.bookinvoice[0]?.state || ''}, ${this.bookinvoice[0]?.country || ''}, ${this.bookinvoice[0]?.pincode || ''}`;
        console.log('Address:', this.address);
      }
    });

    // ✅ Second API: Book Invoice Data
    this.service.getBookOrderDataForView(this.book['rcpt_id']).subscribe((data) => {
      console.log('Book invoice data:', data);
      this.bookinvoicedata = data;

      // Calculate totals
      this.total_amount = 0;
      this.shipping_charges = 0;
      for (let index = 0; index < this.bookinvoicedata.length; index++) {
        this.total_amount += parseInt(this.bookinvoicedata[index]['total'], 10) || 0;
        this.shipping_charges += parseInt(this.bookinvoicedata[index]['shipping_charges'], 10) || 0;
      }

      this.totals = this.total_amount + this.shipping_charges;
      this.toWords = new ToWords();
      this.amtinwords = this.toWords.convert(this.totals, { currency: true });
    });
  }

  print(): void {
    window.print();
  }
}
